import {time2text} from './xp.v1'

export function formatDate(value, fmt){
    if(!value) return;
    let tm = +new Date(value);
    return time2text(tm, fmt)
}
//图片裁切
export function resize(value, w, h){
    if(!value) return;
    let size = '';
    if(w && h){
        size = `x-oss-process=image/resize,m_fill,w_${w},h_${w},limit_0/auto-orient,1/quality,q_90`
        if(value.indexOf('?') !== -1){
            size = '&' + size
        } else {
            size = '?' + size
        }
    }
    return value + size
}

export function fen2yuan(value, fixed, sign){
    if(!value) return 0;
    let s = sign?'¥':'';
    if(fixed){
        return s+(+value/100).toFixed(fixed)
    }
    return s+(Math.round(+value/100))
}

export function getPic(value, index){
    if(!value || !value.length) return '';
    if(index){
        return value[index].content || ''
    }
    return value[0].content || ''
}

export function formatTime(value){
    if(!value || value < 0) return 0;
    let day = Math.floor((value / 3600) / 24);
    let hour = Math.floor((value / 3600) % 24);
    let minute = Math.floor((value / 60) % 60);
    let second = Math.floor((value) % 60);
    if(day > 0){
        return `${day}天 ${formatNumber(hour)}:${formatNumber(minute)}:${formatNumber(second)}`
    }
    if(hour > 0){
        return `${formatNumber(hour)}:${formatNumber(minute)}:${formatNumber(second)}`
    }
    if(minute > 0){
        return `${formatNumber(minute)}:${formatNumber(second)}`
    }
    if(second > 0){
        return `${formatNumber(second)}`
    }

    return ''
}

function formatNumber(value){
    return value < 10 ? '0' + value : value
}